// extracted by mini-css-extract-plugin
export default {"wrapper":"jrLg_ky3qLb3KH7Xg4qS","placeholder":"kFKbZ64bW37Gr9V6eSmz"};